(function () {
    var ImageViewerController = (function () {
        function ImageViewerController() {
            this.init.apply(this, arguments);
        }

        ImageViewerController.prototype = {
            init: function ($scope, $mdDialog, $location, $ionicHistory, $ionicScrollDelegate, $timeout, attachment, attachments, DeviceService) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$location = $location;
                this.$mdDialog = $mdDialog;
                this.$ionicHistory = $ionicHistory;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.attachment = attachment;
                this.attachments = attachments;
                this.deviceService = DeviceService;

                // NF-819: Prevent fire  backbutton to other screen
                this.deviceService.preventBackButton(this.$scope);

                // for managed history we dont need to care for the moment
                // var currentSearch = this.$location.search() || {};
                // this.$location.search(currentSearch);

                // var unregister = $scope.$watch(function () {
                //     return $location.search()
                // }, angular.bind(this, function (params) {
                //     if (!params.showDialog) {
                //         unregister();
                //         this.cancel();
                //     }
                // }));

                this.$scope.$on("$destroy", angular.bind(this, function () {
                    // unregister();
                    if (this.swiper) {
                        this.swiper.destroy();
                    }
                }));


            },
            getInitialSlide: function () {
                var index = _.findIndex(this.attachments, function (attachment) {
                    return attachment['DownloadUrl'] === this.attachment['DownloadUrl'];
                }, this);
                if (index === -1)
                    index = 0;
                return index;
            },
            initSlides: function () {
                var initialSlide = this.getInitialSlide();
                var swiper = new Swiper('#internal-imageviewer-page .swiper-container', {
                    spaceBetween: 30,
                    init: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    initialSlide: initialSlide,
                    preloadImages: false,
                    on: {
                        slideChange: function () {
                            swiper.allowTouchMove = true;
                        }
                    },
                    threshold: 5
                });
                swiper.touchEventsData.formElements = "input, select, option, textarea, button, video,.swiper-pagination-bullet,.swiper-can-click";
                swiper.on('init', angular.bind(this, function () {
                    var activeIndex = swiper.activeIndex;
                    this.attachments[activeIndex].canView = true;
                    this.attachment = this.attachments[activeIndex];
                    this.safeApply();
                }));
                swiper.on('slideChangeTransitionStart', angular.bind(this, function () {
                    this.attachment = this.attachments[swiper.activeIndex];
                    this.safeApply();
                }));
                swiper.on('slideChangeTransitionEnd', angular.bind(this, function () {
                    this.attachment.canView = true;
                    this.safeApply();
                }));
                this.swiper = swiper;
                swiper.init();
            },

            ready: function () {
                this.$element = $("#internal-imageviewer-page");
                this.loaded = true;
                this.initSlides();
                this.safeApply();
            },
            cancel: function () {
                this.$mdDialog.hide();
            },
            safeApply: function (fn) {
                var phase = this.$scope.$root.$$phase;
                if (phase === '$apply' || phase === '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$scope.$apply(fn);
                }
            },
            toggle: function (ev) {
                this.swiper.zoom.toggle(ev);
            }
        };
        ImageViewerController.$inject = ['$scope', '$mdDialog', '$location', '$ionicHistory', '$ionicScrollDelegate', '$timeout', 'attachment', 'attachments', 'DeviceService'];
        return ImageViewerController;
    }());
    angular.module('internal.imageviewer', []).controller('ImageViewerController', ImageViewerController)
})();


